var KEY_ENTER = 13;
var KEY_ESC = 27;
var KEY_DOWN = 38;
var KEY_UP = 40;
var KEY_0 = 48;
var KEY_1 = 49;
var KEY_2 = 50;
var KEY_3 = 51;
var KEY_4 = 52;
var KEY_5 = 53;
var KEY_6 = 54;